module.exports = __webpack_public_path__ + "img/11.3036a91f.png";